(function() {
  'use strict';

  angular.module('app').factory('MessageService', MessageService);

  MessageService.$inject = ['$rootScope', 'API'];

  function MessageService($rootScope, API) {
    var service = {};
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    /**
     * Get list of all or filtered Messages
     */
    service.All = function(params, callback) {
      API.get('/message?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    /**
     * Post reply message
     */
    service.Reply = function(id, data, callback) {
      API.post('/message/{0}/reply'.format(id), data, callback);
    };

    /**
     * Mark as read
     */
    service.MarkAsRead = function(id, callback) {
      API.patch('/message/{0}/readed'.format(id), null, callback);
    };

    /**
     * Send message to all user in search criteria
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     *
     */
    service.Send = function(data, callback) {
      API.post('/message/send', data, callback);
    };

    /**
     * Calculate price of
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.SendPrice = function(data, callback) {
      API.post('/message/send/cost', data, callback);
    };

    /**
     * Send notify message to all user in search criteria above news
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.SendNotification = function(data, callback) {
      API.post('/message/send_notification', data, callback);
    };

    /**
     * Send notify message to users with news by specified channel
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.SendNotificationNews = function(data, callback) {
      API.post('/message/notification/news/send', data, callback);
    };

    return service;
  }

})();
